/* eslint-disable react-hooks/rules-of-hooks */
import { useShallow } from 'zustand/shallow';

import { useRecentHistoryStore } from './recentHistoryStore';

// Getters
export const getPendingView = () =>
	useRecentHistoryStore(useShallow(({ pendingView }) => pendingView));

// Setters
export const useSetPendingView = () =>
	useRecentHistoryStore(state => state.setPendingView);
